(() => {
  const translations = {
    '6eeb5fcc-1f8b-43f6-b1b7-22244905f0f9': ['Thank you so much! Wonderful service and a fantastic watch. It looks very elegant on the wrist. We will definitely order again. Thank you!', 'Latvian', 'lv'],
    '985dd30b-5773-4110-b1ba-d03bafe7193a': ['Thank you, Chronoera!', 'Latvian', 'lv'],
    '7aa36447-7ce6-4ce0-b2bf-c0937463a16a': ['My watch arrived yesterday and I’m very happy! Delivery took a little longer, but at this price it was definitely worth the wait.', 'Lithuanian', 'lt'],
    '52187f5c-e2b7-49e7-b051-42ff615f02f8': ['Thank you—it arrived within a couple of days. Excellent quality.', 'Latvian', 'lv'],
    '09665c22-74dc-4c30-b73e-ee0959f30a98': ['I really like the watch. It feels comfortable on the wrist. You can see the Swiss quality :)', 'Lithuanian', 'lt'],
    '91fa2c85-cdb4-4ad7-9241-d1dc1f9dacab': ['I gave it to my husband as a gift, and he was very happy!', 'Lithuanian', 'lt'],
    '748e5f51-791a-48d8-9385-3396019059c6': ['The most beautiful watch I’ve ever seen! I’m very happy with my purchase!', 'Lithuanian', 'lt'],
    '11946e3c-b1eb-4b99-a072-7de23a9c5b02': ['I bought it as a gift for my son, and he was very happy!', 'Lithuanian', 'lt'],
    '2f33ee30-d37a-4330-9ae1-2328ca42f32a': ['A very beautiful watch, thank you :)', 'Latvian', 'lv'],
    '66641a6a-0381-4d5b-91c8-e4b03e02c59b': ['Very good quality.', 'Latvian', 'lv'],
    'b9396956-69c5-452a-acf7-605333e7b07a': ['Thank you, we received it :)', 'Latvian', 'lv'],
    '21515354-87f6-41fe-b0f0-63d765a0d57e': ['Great!', 'Lithuanian', 'lt']
  };

  const sourceLanguages = {"a31970dd-5773-413e-a2bb-c388600915a2": "en", "f4aa22db-79bf-469a-8d46-2e7e4961e036": "en", "df3a6cb9-b3c4-42bf-b5ef-8fcbb388332b": "en", "7aa36447-7ce6-4ce0-b2bf-c0937463a16a": "lt", "09665c22-74dc-4c30-b73e-ee0959f30a98": "lt", "91fa2c85-cdb4-4ad7-9241-d1dc1f9dacab": "lt", "748e5f51-791a-48d8-9385-3396019059c6": "lt", "11946e3c-b1eb-4b99-a072-7de23a9c5b02": "lt", "21515354-87f6-41fe-b0f0-63d765a0d57e": "lt", "4c23fcef-8b46-4529-8c0d-0ebc88a7835c": "lt", "a6c88b7a-bf40-4bc7-ab45-064d6dfcb720": "lt", "48f350a4-1e4f-4010-b2b0-0780deeb7049": "ru", "c39cd169-3dfb-49e6-8cf7-8828457fcb6c": "lt"};

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  class ChronoeraReviews extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const localeData = JSON.parse(this.querySelector('[data-review-i18n]')?.textContent || '{}');
      this.locale = localeData.locale || 'en';
      this.labels = Object.fromEntries(Object.entries(localeData.strings || {}).map(([key, value]) => [key, String(value).trim()]));
      this.label = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`__${name}__`, value), this.labels[key] || key);
      this.track = this.querySelector('[data-review-track]');
      this.counter = this.querySelector('[data-review-position]');
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (this.dataset.source === 'judgeme') this.buildJudgeReviews();
      this.cards = Array.from(this.track.children);
      if (!this.cards.length) {
        this.closest('.ch-customer-reviews')?.setAttribute('hidden', '');
        return;
      }
      this.querySelector('[data-review-loading]')?.remove();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-review-card]');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant' });
      }, options);
      this.update();
    }

    buildJudgeReviews() {
      const source = this.querySelector('[data-judge-source]');
      if (!source) return;
      this.track.replaceChildren();
      const nodes = Array.from(source.content.querySelectorAll('.jdgm-carousel-item'));
      const leadReviews = ['df3a6cb9-b3c4-42bf-b5ef-8fcbb388332b', '6eeb5fcc-1f8b-43f6-b1b7-22244905f0f9', '7aa36447-7ce6-4ce0-b2bf-c0937463a16a'];
      const priority = review => leadReviews.includes(review.dataset.reviewId) ? leadReviews.indexOf(review.dataset.reviewId) : leadReviews.length;
      nodes.sort((a, b) => priority(a) - priority(b));
      const seen = new Set();
      for (const review of nodes) {
        const id = review.dataset.reviewId;
        if (!id || seen.has(id)) continue;
        seen.add(id);
        const read = selector => review.querySelector(selector)?.textContent.trim() || '';
        const original = read('.jdgm-carousel-item__review-body');
        if (!original) continue;
        const sourceLanguage = translations[id]?.[2] || sourceLanguages[id] || '';
        const translated = /^(lt|lv)/.test(this.locale)
          ? (id !== 'a31970dd-5773-413e-a2bb-c388600915a2' && sourceLanguage && sourceLanguage !== this.locale.split('-')[0] && this.labels['body_' + id] ? [this.labels['body_' + id], this.labels['language_' + sourceLanguage] || sourceLanguage, sourceLanguage] : null)
          : (this.locale.startsWith('en') ? translations[id] : null);
        const ratingNode = review.querySelector('.jdgm-carousel-item__review-rating');
        const rating = Number.parseInt(ratingNode?.getAttribute('aria-label'), 10) || ratingNode?.querySelectorAll('.jdgm--on').length || 0;
        if (!Number.isInteger(rating) || rating < 1 || rating > 5) continue;
        const card = element('article', 'ch-review-card ch-review-card--product');
        card.dataset.reviewCard = '';
        card.dataset.reviewId = id;
        card.lang = translated ? this.locale : sourceLanguage || this.locale;
        const top = element('div', 'ch-review-card__top');
        const stars = element('span', 'ch-review-stars', '★'.repeat(rating) + '☆'.repeat(5 - rating));
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', this.label('stars', { rating }));
        top.append(stars, element('span', 'ch-review-card__source', 'Judge.me'));
        const quote = element('blockquote', 'ch-review-card__quote', translated ? translated[0] : original);
        const author = element('div', 'ch-review-card__author');
        author.append(element('strong', '', (read('.jdgm-carousel-item__reviewer-name') === 'Anonymous' ? this.label('anonymous') : read('.jdgm-carousel-item__reviewer-name')) || this.label('anonymous')));
        const rawDate = review.querySelector('.jdgm-carousel-item__timestamp')?.dataset.time;
        if (rawDate) {
          const [month, day, year] = rawDate.split('/').map(Number);
          const date = new Date(Date.UTC(year, month - 1, day));
          if (!Number.isNaN(date.getTime())) {
            const time = element('time', '', new Intl.DateTimeFormat(this.locale === 'en' ? 'en-GB' : this.locale, { day: 'numeric', month: this.locale.startsWith('lt') ? 'long' : 'short', year: 'numeric', timeZone: 'UTC' }).format(date));
            time.dateTime = date.toISOString().slice(0, 10);
            author.append(time);
          }
        }
        card.append(top, quote, author);
        if (translated) {
          const details = element('details', 'ch-review-original');
          details.append(element('summary', '', this.label('translated_original', { language: this.labels['language_' + translated[2]] || translated[1] })));
          const text = element('p', '', original);
          text.lang = translated[2];
          details.append(text);
          card.append(details);
        }
        const sourceImage = review.querySelector('.jdgm-carousel-item__product-image');
        if (sourceImage) {
          const product = element('div', 'ch-review-card__product');
          const image = element('img', '');
          const url = sourceImage.dataset.srcRetina || sourceImage.dataset.src || sourceImage.getAttribute('src');
          if (url && /^(https:)?\/\//.test(url)) image.src = url;
          image.alt = '';
          image.width = 56;
          image.height = 64;
          image.loading = 'lazy';
          const originalTitle = sourceImage.alt || this.label('watch');
          const lvProductTitles = {"AR11586":"Emporio Armani Chronograph — zaļa ciparnīca · AR11586","AR2434":"Emporio Armani Renato — melna ciparnīca · AR2434","SRPD53K1":"Seiko 5 Sports 42,5 mm — zila ciparnīca (“Pepsi”) · SRPD53K1"};
          const ltProductTitles = {"AR11586": "Emporio Armani AR11586 – chronografas, žalias ciferblatas", "AR2434": "Emporio Armani Renato AR2434 – juodas ciferblatas", "SRPD53K1": "Seiko 5 Sports SRPD53K1 – automatinis, mėlynas ciferblatas („Pepsi“)", "SRPK24": "Seiko 5 Sports SRPK24 – automatinis, rudas ciferblatas, dvispalvė apyrankė", "SRPC25J1": "Seiko Prospex Turtle „Deep Blue Batman“ SRPC25J1 – automatinis nardymo laikrodis", "T120.417.11.041.00": "Tissot Seastar 1000 T120.417.11.041.00 – chronografas, mėlynas ciferblatas", "T137.210.11.091.00": "Tissot PRX 35 mm T137.210.11.091.00 – mėtų spalvos ciferblatas", "T120.410.11.041.00": "Tissot Seastar 1000 T120.410.11.041.00 – mėlynas ciferblatas", "T058.009.33.031.01": "Tissot Lovely Round T058.009.33.031.01 – aukso spalvos", "SRPD51K1": "Seiko 5 Sports SRPD51K1 – automatinis, mėlynas ciferblatas", "SSK003K1": "Seiko 5 Sports GMT SSK003K1 – automatinis, mėlynas ciferblatas („Batman“)", "T137.410.11.051.00": "Tissot PRX 40 mm T137.410.11.051.00 – juodas ciferblatas", "T137.410.11.041.00": "Tissot PRX 40 mm T137.410.11.041.00 – mėlynas ciferblatas"};
          const productTitles = this.locale.startsWith('lt') ? ltProductTitles : lvProductTitles;
          const matchedModel = Object.keys(productTitles).find(model => originalTitle.includes(model));
          const productTitle = /^(lt|lv)/.test(this.locale) && matchedModel ? productTitles[matchedModel] : originalTitle;
          product.append(image, element('span', '', productTitle));
          card.append(product);
        }
        this.track.append(card);
      }
    }

    update() {
      if (!this.cards?.length) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previous.disabled = this.track.scrollLeft < 3;
      this.next.disabled = this.track.scrollLeft >= max - 3;
      const origin = this.cards[0].offsetLeft;
      this.index = this.cards.reduce((best, card, index) => Math.abs(card.offsetLeft - origin - this.track.scrollLeft) < Math.abs(this.cards[best].offsetLeft - origin - this.track.scrollLeft) ? index : best, 0);
      this.counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.cards.length).padStart(2, '0')}`;
      this.cards.forEach((card, index) => card.setAttribute('aria-label', this.label('review_position', { index: index + 1, total: this.cards.length })));
    }

    move(direction) {
      const index = Math.min(this.cards.length - 1, Math.max(0, this.index + direction));
      this.track.scrollTo({
        left: this.cards[index].offsetLeft - this.cards[0].offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.abort = null;
    }
  }

  if (!customElements.get('chronoera-reviews')) customElements.define('chronoera-reviews', ChronoeraReviews);
})();


